import { v4 as uuidv4 } from 'uuid';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactPaginate from "react-paginate";
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/Add';
import TableRow from '@mui/material/TableRow';
import { tr } from 'date-fns/locale';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import UndoIcon from '@mui/icons-material/Undo';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import Tooltip from '@mui/material/Tooltip';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Grid from '@mui/material/Grid';
import BomMainDataGrid from './BomMainDataGrid';
import BomActions from './BomActions';
import { apiUrl } from '../../apiUrl/ApiUrl';


export default function Bom({ data }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [newData, setNewData] = useState(null);
  const [inputValue, setInputValue] = useState("58085400");
  const [mainBom, setMainBom] = useState({
    DrawNum: '',
    ItemName: '',
    BuildDate: '',
    PreDays: 0
  });
  const [detailBom, setDetailBom] = useState({
    Order: '',
    detailDrawNum: '',
    ItemName: '',
    GiveAmount: 0,
    Chk: ''
  });
  const [detailBoms, setDetailBoms] = useState([]);
  const [editedRows, setEditedRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [detailOptions, setDetailsOptions] = useState([]);
  const [item, setItem] = useState('');
  const [addBillRows, setAddBillRows] = useState([]);
  const [selectedMainDrawNum, setSelectedMainDrawNum] = useState(null); // 保存主件圖號
  const [viewHistory, setViewHistory] = useState([]); // 最近 2 次右側視圖快照

  const [detailedData, setDetailedData] = useState(null); // 保存詳細資料
  const [openSubDialog, setOpenSubDialog] = useState(false);
  const [subBomRows, setSubBomRows] = useState([]);

  const columns = [
    
    {
      field: 'orderBy',
      headerName: '序',
      width: 60,
      editable: true,
    },
    {
      field: 'detailDrawNum',
      headerName: '子件圖號',
      width: 140,
      editable: true,
    },
    {
      field: 'itemName',
      headerName: '物品名',
      width: 200,
      editable: true,
    },
    {
      field: 'chk',
      headerName: 'CHK',
      width: 60,
      editable: true,
    },
    {
      field: 'dispenseAmount',
      headerName: '配賦量',
      type: 'number',
      sortable: false,
      width: 80,
    },
    {
      field: 'actions',
      headerName: '操作',
      width: 150,
      type: 'actions',
      renderCell: (params) => <BomActions params={params} setRows={setRows} />
    },
    { field: 'id', headerName: 'ID', width: 90 },
  ];

  const columnsList = [
    
    {
      field: 'mainDrawNum',
      headerName: '主件圖號',
      width: 140,
      editable: true,
    },
    {
      field: 'itemName',
      headerName: '物品名',
      width: 200,
      editable: true,
    },
    
    { field: 'id', headerName: 'ID', width: 90 },
    
  ];

  const detailColumns = [
    { field: 'id', headerName: 'ID', width: 40 },
    {
      field: 'Order',
      headerName: '序',
      width: 40,
      editable: true,
    },
    {
      field: 'detailDrawNum',
      headerName: '子件圖號',
      width: 120,
      editable: true,
    },
    {
      field: 'ItemName',
      headerName: '物品名',
      width: 120,
      editable: true,
    },
    {
      field: 'Chk',
      headerName: 'CHK',
      width: 40,
      editable: true,
    },
    {
      field: 'GiveAmount',
      headerName: '配賦量',
      type: 'number', // 修正類型為 'number'
      sortable: false,
      width: 60,
    },
    {
      field: 'actions',
      headerName: '操作',
      width: 40,
      type: 'actions',
      renderCell: (params) =>
        <Button
          variant="outlined"
          endIcon={<DeleteForeverIcon />}
          onClick={() => handleClear(params.row.detailDrawNum)}
        />
    }
  ];

  useEffect(() => {
    if (data && data.boms) {
      setRows(data.boms);
    }
  }, [data]);

  const handleBack = () => {
      setViewHistory(prev => {
        if (prev.length === 0) return prev;           // 沒有可回復的快照
        const [last, ...rest] = prev;                 // 取出最近的一筆
        setRows(last.rows);                           // 還原右側 DataGrid 的資料
        setSelectedMainDrawNum(last.selectedMainDrawNum); // 還原標題上的主件編號
        return rest;                                  // 移除已使用的快照
      });
    };
    

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClear = (detailDrawNum) => {
    const newArray = detailBoms.filter(item => item.detailDrawNum !== detailDrawNum);
    setDetailBoms(newArray);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}/Bom/EditDetails`, editedRows);
      if (response.data.statusCode === 200) {
        setRows(response.data.boms);
        setNewData(response.data);
        alert('修改成功');
      } else {
        alert('修改失敗');
      }
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      alert('修改失敗');
    }finally{
      setLoading(false);
    }
  };

  const processRowUpdate = (newRow, oldRow) => {
    const index = editedRows.findIndex(row => row.id === newRow.id);
    if (index > -1) {
      editedRows.splice(index, 1);
    }
    setEditedRows([...editedRows, newRow]);
    return newRow;
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/Bom/GetMain`, {
        params: { drawNum: inputValue.trim() }
      });

      if (response.data.bom != null) {
        console.log(response.data.bom);
        setRows(response.data.boms);
        setNewData(response.data);
        alert('搜尋成功');
      } else {
        alert('搜尋失敗');
      }
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      alert('搜尋失敗');
    }finally{
      setLoading(false);
    }
  };

  const handleInputChange = (event, propertyName) => {
    const value = event.target ? event.target.value : event;
    setMainBom((prevData) => ({
      ...prevData,
      [propertyName]: value,
    }));
  };

  const handleInsertDetail = () => {
    if (!item || !item.圖號) {
      alert('請先從「料品選擇」中選擇一個子件');
      return;
    }
  
    const newDetail = {
      ...detailBom,
      detailDrawNum: item.圖號,
      ItemName: item.物品名,
      id: uuidv4()
    };
  
    setDetailBoms((prevItems) => [...prevItems, newDetail]);
    console.log('當前 detailBoms:', [...detailBoms, newDetail]);

    // 清空 detailBom 與 item，避免連續輸入錯誤
    setDetailBom({
      Order: '',
      detailDrawNum: '',
      ItemName: '',
      GiveAmount: 0,
      Chk: ''
    });
    setItem('');
  };
  

  const handleDetailInputChange = (event, propertyName) => {
    const value = event.target ? event.target.value : event;
    setDetailBom((prevData) => ({
      ...prevData,
      [propertyName]: value,
    }));
  };

  const handleDetailsOptionsClick = async (no) => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/PurchasePrice/ItemOptions`, {
        params: { num: no, vendor: '' },
      });
      if (response.status === 200) {
        setDetailsOptions(response.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }finally{
      setLoading(false);
    }
  };

  const handleMainDrawNumSelect = async (mainDrawNum) => {
    setLoading(true);
    setSelectedMainDrawNum(mainDrawNum);
    console.log("選中的主件圖號: ", mainDrawNum);
    
    try {
      const response = await axios.get(`${apiUrl}/Bom/GetMainDetails`, {
        params: { drawNum: mainDrawNum },
      });
      if (response.data.boms != null) {
        // 先把目前的右側視圖快照存進歷史（最多 2 份）
        setViewHistory(prev => {
          if (!rows || rows.length === 0) return prev; // 第一次或無資料就不存
          return [{ rows, selectedMainDrawNum }, ...prev].slice(0, 3);
        });
        // console.log(response.data.bom);
        setRows(response.data.boms);
        alert('搜尋成功');
      } else {
        alert('搜尋失敗');
      }
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      alert('搜尋失敗');
    }finally{
      setLoading(false);
    }
  };

  const handleQuerySubBom = async (drawNum) => {
    setLoading(true);
    try {
      // 這裡根據你API自行調整
      const response = await axios.get(`${apiUrl}/Bom/GetSubBoms`, { params: { drawNum } });
      if (response.status === 200 && Array.isArray(response.data.boms)) {
        setSubBomRows(response.data.boms); // 確保 DataGrid 有 id
        setOpenSubDialog(true);
      } else {
        alert('查無資料');
      }
    } catch (error) {
      alert('查詢失敗');
    } finally {
      setLoading(false);
    }
  };
  

  const handleRowDoubleClick = async (params) => {
    setLoading(true);
    console.log('雙擊事件觸發:', params); // 調試輸出
    const drawNum = params.row.detailDrawNum;
    setSelectedMainDrawNum(drawNum); 

    try {
      const response = await axios.get(`${apiUrl}/Bom/GetMainDetails`, {
        params: { drawNum },
      });

      if (response.status === 200 && response.data) {
              // 同樣先存現在的視圖快照
      setViewHistory(prev => {
        if (!rows || rows.length === 0) return prev;
        return [{ rows, selectedMainDrawNum }, ...prev].slice(0, 3);
      });
        setRows(response.data.boms);
        alert('成功取得詳細資料');
      } else {
        alert('未找到對應的詳細資料。');
      }
    } catch (error) {
      console.error('資料抓取失敗:', error);
      alert('抓取詳細資料時發生錯誤。');
    }finally{
      setLoading(false);
    }
  };

  const handleDetailChange = (event) => {
    const selectedItem = event.target.value;
    setItem(selectedItem);
    setAddBillRows(prevAddBillRows => [...prevAddBillRows, selectedItem]);
    setDetailBom(prevDetailBom => ({
      ...prevDetailBom,
      detailDrawNum: selectedItem.圖號,
      ItemName: selectedItem.物品名
    }));
  };

  const handleSubmit = async () => { 
    setLoading(true);  
    try {
      const request = {
        Bom: mainBom,
        BomDetailModels: detailBoms
      };
      const response = await axios.post(`${apiUrl}/Bom/NewBom`, request);
      if (response.status === 200) {
        setRows(response.data.boms);
        setNewData(response.data);
        handleClose();
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert('失敗 欄位有誤');
    } finally{
      setLoading(false);
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" margin="20px 0" sx={{ width: '95%', margin: 'auto', marginTop: '40px', marginBottom: '20px' }}>
      <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        <TextField
          required
          id="outlined-required"
          label="圖號"
          defaultValue="58085400"
          onChange={(e) => setInputValue(e.target.value)}
        />
        <Stack direction="row" spacing={2} sx={{ marginLeft: '40px' }}>
          <Button variant="contained" endIcon={<SendIcon />} onClick={handleSearch}>
            搜尋
          </Button>
          <Button variant="contained" endIcon={<AddIcon />} onClick={handleClickOpen}>
            新增
          </Button>
          <Button variant="outlined" onClick={() => handleQuerySubBom(inputValue)}>
          查詢上階BOM
          </Button>
        </Stack>
      </Box>
      {/* 雙欄佈局：左 45%｜中 5%（空白）｜右 45% */}
<Box
  sx={{
    width: '95%',
    mx: 'auto',
    mt: 2,
    mb: '6%',
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: '35% 5% 60%' },
    columnGap: 2,
    rowGap: 2,
    alignItems: 'stretch',
    '& > *': { minWidth: 0 }, // 避免內容溢出造成寬度不一致
  }}
>
  {/* 左 45%：主件清單 */}
<Paper elevation={2}
  sx={{ p: 2, height: { xs: 420, md: 560 }, display: 'flex', flexDirection: 'column' }}
>
  {/* 標題列 */}
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
    <Box sx={{ fontWeight: 700 }}>主件</Box>
  </Box>

  {/* 讓內層撐滿高度 + 寬度 */}
  <Box
    sx={{
      flex: 1,
      minHeight: 0,
      display: 'flex',                         // ★ 讓子元件能用 flex:1 撐滿
      '& .MuiDataGrid-root': { width: '100%', height: '100%' },
    }}
  >
    <BomMainDataGrid
      data={data}
      newData={newData}
      rowHeight={38}
      headerHeight={32}
      onMainDrawNumSelect={handleMainDrawNumSelect}
      sx={{ flex: 1, width: '100%', height: '100%' }}   // ★ 重要：帶 height + flex
    />
  </Box>
</Paper>


  {/* 中 5%：空白分隔（如需垂直線可在裡面加一條 border） */}
  <Box sx={{ display: { xs: 'none', md: 'block' } }} />

  {/* 右 45%：子件明細（DataGrid） */}
  <Paper elevation={2} sx={{ p: 2, height: { xs: 420, md: 560 }, display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
      <Box sx={{ fontWeight: 700 }}>
        明細 {selectedMainDrawNum ? `（主件：${selectedMainDrawNum}）` : ''}
      </Box>
      <Tooltip title={viewHistory.length ? "回到上一個視圖" : ""}>
      <span>
        <Button
          size="small"
          variant="outlined"
          startIcon={<UndoIcon />}
          onClick={handleBack}
          disabled={viewHistory.length === 0}
        >
          上一步
        </Button>
      </span>
    </Tooltip>
      <Tooltip title="儲存目前修改">
        <Button
          size="small"
          variant="outlined"
          startIcon={<SaveIcon />}
          onClick={handleSave}
        >
          儲存
        </Button>
      </Tooltip>
    </Box>

    {/* DataGrid 需有固定高度容器，這裡用 flex:1 + minHeight:0 讓它吃滿 */}
    <Box sx={{ flex: 1, minHeight: 0 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: { paginationModel: { pageSize: 10 } },
        }}
        editMode="row"
        pageSizeOptions={[10, 20]}
        disableRowSelectionOnClick
        rowHeight={30}
        headerHeight={32}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={(error) => alert(error)}
        onRowEditCommit={(rowId, e) => handleSave(rowId, e)}
        onRowDoubleClick={handleRowDoubleClick}
      />
    </Box>
  </Paper>
</Box>


      <Dialog open={open} onClose={handleClose} >
        <DialogTitle>新增Bom</DialogTitle>
        <DialogContent >
          <Grid container spacing={2}>
            <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                id="standard-search"
                label="主件圖號"
                type="search"
                variant="standard"
                value={mainBom.DrawNum}
                onChange={(e) => handleInputChange(e, 'DrawNum')}
              />
            </Grid>
            <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                id="standard-search"
                label="物品名"
                type="search"
                variant="standard"
                value={mainBom.ItemName}
                onChange={(e) => handleInputChange(e, 'ItemName')}
              />
            </Grid>
            <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                id="standard-search"
                label="建檔日期"
                type="search"
                variant="standard"
                value={mainBom.BuildDate}
                onChange={(e) => handleInputChange(e, 'BuildDate')}
              />
            </Grid>
            <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                id="standard-search"
                label="提前天數"
                type="search"
                variant="standard"
                onChange={(e) => handleInputChange(e, 'PreDays')} // 修正為 'PreDays'
                value={mainBom.PreDays}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" endIcon={<AddIcon />} onClick={handleInsertDetail}>
                新增BOM細項
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center' }}>
                  <TextField
                    id="standard-search"
                    label="序"
                    type="search"
                    variant="standard"
                    value={detailBom.Order}
                    onChange={(e) => handleDetailInputChange(e, 'Order')}
                  />
                </Grid>
                <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                  <TextField
                    id="standard-search"
                    label="子件圖號"
                    type="search"
                    variant="standard"
                    value={detailBom.detailDrawNum}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleDetailsOptionsClick(detailBom.detailDrawNum);
                        e.preventDefault(); // 防止表單提交
                      }
                    }}
                    onChange={(e) => handleDetailInputChange(e, 'detailDrawNum')}
                  />
                </Grid>
                <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                  <TextField
                    id="standard-search"
                    label="物品名"
                    type="search"
                    variant="standard"
                    value={detailBom.ItemName}
                    onChange={(e) => handleDetailInputChange(e, 'ItemName')}
                  />
                </Grid>
                <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center' }}>
                  <TextField
                    id="standard-search"
                    label="配賦量"
                    type="search"
                    variant="standard"
                    onChange={(e) => handleDetailInputChange(e, 'GiveAmount')}
                    value={detailBom.GiveAmount}
                  />
                </Grid>
                <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center' }}>
                  <TextField
                    id="standard-search"
                    label="CHK"
                    type="search"
                    variant="standard"
                    onChange={(e) => handleDetailInputChange(e, 'Chk')}
                    value={detailBom.Chk}
                  />
                </Grid>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">料品選擇</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={item}
                    label="料品選擇"
                    onChange={handleDetailChange}
                  >
                    {detailOptions.map((item) => (
                      <MenuItem key={item.id} value={item}>
                        圖號:{item.圖號} 物品名:{item.物品名} 單位:{item.單位} 單價:{item.單價}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ height: '300px' }}>
              <DataGrid
                rows={detailBoms}
                columns={detailColumns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                
                pageSizeOptions={[10, 20]}
                onRowDoubleClick={handleRowDoubleClick} // 綁定雙擊事件
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>取消</Button>
          <Button onClick={handleSubmit}>送出</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openSubDialog} onClose={() => setOpenSubDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>上階BOM（子件圖號 = {inputValue}）</DialogTitle>
        <DialogContent>
          <div style={{ height: 420, width: '100%' }}>
            <DataGrid
              rows={subBomRows}
              columns={columnsList} // 可以用和主畫面一樣的 columns
              pageSize={10}
              rowHeight={30}
              headerHeight={32} 
              rowsPerPageOptions={[10, 20]}
            />
          </div>
          </DialogContent>
          <DialogActions>
          <Button onClick={() => setOpenSubDialog(false)}>關閉</Button>
          </DialogActions>
      </Dialog>


      {/* 詳細資料顯示區域 */}
      <Box sx={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
        {detailedData ? (
          <Paper elevation={3} sx={{ padding: '20px' }}>
            <h3>詳細資料</h3>
            <Grid container spacing={2}>
              {/* 根據 response.data 的結構自訂顯示內容 */}
              <Grid item xs={6}>
                <strong>圖號:</strong> {detailedData.DetailDrawNum}
              </Grid>
              <Grid item xs={6}>
                <strong>物品名:</strong> {detailedData.ItemName}
              </Grid>
              {/* 根據您的資料結構添加更多欄位 */}
            </Grid>
          </Paper>
        ) : (
          <Box sx={{ textAlign: 'center', marginTop: '20px' }}>
            <em>雙擊一行以查看詳細資料。</em>
          </Box>
        )}
      </Box>
    </>
  );
};
